<template>
  <div>
    <!-- <ValidationObserver ref="form" v-slot="{ invalid }"> -->
    <Form v-slot="{ errors, meta }" onsubmit="return false;">
      <main class="cf">
        <div class="container">
          <section class="common_section intro_info">
            <h2>ご入会手続きの流れ</h2>
            <div class="intro_flow">
              <ul class="flow_fig">
                <li class="flow_1">
                  <span>1</span>
                  <img
                    src="@/assets/img/icon_stepfig_1.png"
                    srcset="
                      @/assets/img/icon_stepfig_1.png    1x,
                      @/assets/img/icon_stepfig_1@2x.png 2x
                    "
                    alt="step1"
                    width="100"
                    height="100"
                  />
                  <br />WEB上の画面から <br />メールアドレスのご登録
                </li>
                <li class="flow_2">
                  <span>2</span>
                  <img
                    src="@/assets/img/icon_stepfig_2.png"
                    srcset="
                      @/assets/img/icon_stepfig_2.png    1x,
                      @/assets/img/icon_stepfig_2@2x.png 2x
                    "
                    alt="step2"
                    width="100"
                    height="100"
                  />
                  <br />受信したメールから <br />リンクを開き規約を確認
                </li>
                <li class="flow_3">
                  <span>3</span>
                  <img
                    src="@/assets/img/icon_stepfig_3.png"
                    srcset="
                      @/assets/img/icon_stepfig_3.png    1x,
                      @/assets/img/icon_stepfig_3@2x.png 2x
                    "
                    alt="step3"
                    width="100"
                    height="100"
                  />
                  <br />会員情報のご登録
                </li>
                <li class="flow_4">
                  <span>4</span>
                  <img
                    src="@/assets/img/icon_stepfig_4.png"
                    srcset="
                      @/assets/img/icon_stepfig_4.png    1x,
                      @/assets/img/icon_stepfig_4@2x.png 2x
                    "
                    alt="step4"
                    width="100"
                    height="100"
                  />
                  <br />入力内容のご確認
                </li>
                <li class="flow_5">
                  <span>5</span>
                  <img
                    src="@/assets/img/icon_stepfig_5.png"
                    srcset="
                      @/assets/img/icon_stepfig_5.png    1x,
                      @/assets/img/icon_stepfig_5@2x.png 2x
                    "
                    alt="step5"
                    width="100"
                    height="100"
                  />
                  <br />クレジットカード <br />情報のご登録
                </li>
                <li class="flow_6">
                  <span>6</span>
                  <img
                    src="@/assets/img/icon_stepfig_6.png"
                    srcset="
                      @/assets/img/icon_stepfig_6.png    1x,
                      @/assets/img/icon_stepfig_6@2x.png 2x
                    "
                    alt="step6"
                    width="100"
                    height="100"
                  />
                  <br />スマホアプリを <br />インストール
                </li>
              </ul>
            </div>
            <p class="intro_memo" v-html="webContents.article.introMemo"></p>
          </section>

          <section v-if="serviceList.length > 0" class="common_section transfer_info">
            <h2>会員情報の引き継ぎについて</h2>
            <div class="box cf">
              以下のカーシェアリングサービスで会員登録済みの場合は、会員情報の一部を引き継ぐことができます。
              <br />既に会員情報の確認が完了している場合、入会手続き後すぐにカーシェアをご利用いただけます。
              <div class="exchange_list">
                <div class="exchange_list_eemo">
                  <img
                    :src="webContents.images.exchange"
                    :srcset="`${webContents.images.exchange} 1x, ${webContents.images.exchange2x} 2x`"
                    alt="会員登録済みのカーシェアリング"
                    width="106"
                  />
                </div>
                <div class="exchange_list_arrow">
                  <img
                    src="@/assets/img/exchange_arrow.png"
                    srcset="
                      @/assets/img/exchange_arrow.png    1x,
                      @/assets/img/exchange_arrow@2x.png 2x
                    "
                    alt="exchange"
                    width="57"
                    height="33"
                  />
                </div>
                <div class="exchange_items" v-html="serviceLogo"></div>
              </div>
            </div>
          </section>

          <section class="common_section necessary_info">
            <h2>入会手続きに必要なもの</h2>
            <div class="box cf">
              <h4>1. 免許証の画像</h4>
              <img
                :src="webContents.images.license"
                :srcset="`${webContents.images.license} 1x, ${webContents.images.license2x} 2x`"
                alt="免許証"
                width="154"
                height="102"
                class="fig_license"
              />
              <p v-html="webContents.article.licenseInfo"></p>
              <a
                :href="corpParam.licenseNotesUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="info_link"
                >運転免許証に関する注意事項</a
              >
              <p v-html="webContents.article.IndividualNumberlicenseInfo"></p>
            </div>

            <div class="box cf">
              <h4>2. クレジットカード</h4>
              <p v-html="webContents.article.cardInfo"></p>
              <img
                :src="webContents.images.creditCard"
                :srcset="`${webContents.images.creditCard} 1x, ${webContents.images.creditCard2x} 2x`"
                alt="クレジットカード"
                width="270"
                height="33"
                class="fig_cards"
              />
            </div>

            <div class="box cf">
              <h4>3. スマートフォン</h4>
              <p v-html="webContents.article.spInfo"></p>
              <div class="app_bnrs">
                <a :href="corpParam.appleStoreUrl" target="_blank" rel="noopener noreferrer">
                  <img
                    src="@/assets/img/bnr_appstore.png"
                    srcset="@/assets/img/bnr_appstore.png 1x, @/assets/img/bnr_appstore@2x.png 2x"
                    alt="AppStoreからダウンロード"
                    width="159"
                    height="47"
                  />
                </a>
                <a :href="corpParam.googlePlayUrl" target="_blank" rel="noopener noreferrer">
                  <img
                    src="@/assets/img/bnr_googleplay.png"
                    srcset="
                      @/assets/img/bnr_googleplay.png    1x,
                      @/assets/img/bnr_googleplay@2x.png 2x
                    "
                    alt="GooglePlayで手に入れよう"
                    width="169"
                    height="49"
                  />
                </a>
              </div>
            </div>
          </section>

          <section class="common_section optional_info">
            <h2>任意書類</h2>
            <div class="box">
              <h5>運転免許証と現在のお住まいが異なる方</h5>
              <p v-html="webContents.article.optionalInfo"></p>
            </div>
          </section>

          <section class="common_section section_apply">
            <div v-show="registered" class="download_apps">
              <p class="caution" v-html="caution"></p>
              <div class="app_bnrs">
                <a :href="corpParam.appleStoreUrl" target="_blank" rel="noopener noreferrer">
                  <img
                    src="@/assets/img/bnr_appstore.png"
                    srcset="@/assets/img/bnr_appstore.png 1x, @/assets/img/bnr_appstore@2x.png 2x"
                    alt="AppStoreからダウンロード"
                    width="159"
                    height="47"
                  />
                </a>
                <a :href="corpParam.googlePlayUrl" target="_blank" rel="noopener noreferrer">
                  <img
                    src="@/assets/img/bnr_googleplay.png"
                    srcset="
                      @/assets/img/bnr_googleplay.png    1x,
                      @/assets/img/bnr_googleplay@2x.png 2x
                    "
                    alt="GooglePlayで手に入れよう"
                    width="169"
                    height="49"
                  />
                </a>
              </div>
            </div>
            <div class="registration">
              <label for="email">メールアドレス</label>
              <Field
                id="email"
                v-model="email"
                type="text"
                class="input"
                name="メールアドレス"
                rules="mail_format|required|max:128"
              />
              <br />
              <ErrorMessage name="メールアドレス" style="color: red" />
              <!-- <ValidationProvider
                  id="email"
                  rules="mail_format|required|max:128"
                  name="メールアドレス"
                  v-slot="{ errors }"
                >
                  <span>メールアドレス</span>
                  <input
                    name="email"
                    class="input"
                    type="text"
                    size="20"
                    placeholder="例: sample@sample.com"
                    v-model="email"
                  />
                  <br />
                  <span style="color: red">{{ errors[0] }}</span>
                </ValidationProvider> -->
              <p v-html="webContents.article.privacyInfo"></p>
            </div>
          </section>
          <div class="btn_area">
            <button
              id="form-submit"
              type="button"
              :class="
                !meta.touched || Object.keys(errors).length !== 0
                  ? 'btn_l btn_gray not-allowed'
                  : 'btn_l btn_blue'
              "
              :style="wait"
              :disabled="!meta.touched || Object.keys(errors).length !== 0 || disabledFlg"
              @click.stop.prevent="register"
            >
              申し込み
            </button>
          </div>
        </div>
      </main>
    </Form>
    <!-- </ValidationObserver> -->
  </div>
</template>

<script>
import Config from "@/conf/Config";
import ErrorTracking from "@/module/ErrorTracking";
import { ErrorMessage, Field, Form } from "vee-validate";

const axios = require("axios");
const Swal = require("sweetalert2");

const SUBMIT_INTERVAL = 1500;
const API_CONFIG_HOST = window.location.origin;
const API_PATH = {
  CARSHARE_CORP_PARAM: `${API_CONFIG_HOST}/admin/api/common/carshare_corp_param?domain=${API_CONFIG_HOST}`,
  SERVICE_LIST: `${API_CONFIG_HOST}/admin/api/common/service_list_web`,
  COGNITO_SIGN_UP: `${API_CONFIG_HOST}/admin/api/members/cognito_sign_up`,
  TRANSFER_SIGN_UP: `${API_CONFIG_HOST}/admin/api/members/transfer_sign_up`,
};
const SIGNUP_CODE = {
  SUCCESS: 0,
  REGISTERED: 1,
  DIVERSION: 2,
};
const ARTICLE = {
  REGISTERED:
    "入力されたメールアドレスは既に登録済みです。<br/>以下のリンクよりアプリをインストールしてログインしてください。",
  NOT_TRANSFER: "会員情報を引き継がない場合は別のメールアドレスでご登録をお願いいたします。",
  SYSTEM_ERROR:
    "システムエラーが発生しました。<br>ご不便とご面倒をおかけしますが、しばらく時間をおいてから再度ご利用ください。",
};

/* global CARSHARE_CORP_ID */
export default {
  name: "IndexLayout",
  components: {
    ErrorMessage,
    Field,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
  },
  data() {
    return {
      corpParam: {},
      serviceList: [],
      belongServiceList: [],
      email: "",
      registered: false,
      disabledFlg: false,
      wait: "",
      caution: ARTICLE.REGISTERED,
    };
  },
  computed: {
    screenId: () => "ENTR_001",
    webContents() {
      let ret = { article: "", images: "" };
      if (this.corpParam && this.corpParam.memberRegistrationWebContents) {
        ret = JSON.parse(this.corpParam.memberRegistrationWebContents)[this.screenId];
      }
      return ret;
    },
    belongServiceNames() {
      let nameList = "";
      this.belongServiceList.forEach((s) => {
        nameList += `<li>${s.serviceName}</li>`;
      });
      return `<ul>${nameList}</ul>`;
    },
    serviceNames() {
      let nameList = "";
      this.serviceList.forEach((s) => {
        nameList += `<li>${s.serviceName}</li>`;
      });
      return `<ul>${nameList}</ul>`;
    },
    serviceLogo() {
      let nameList = "";
      this.serviceList.forEach((s) => {
        nameList += `<div class="exchange_item" >
        <image src="${s.appImageUrl}" alt="${s.serviceName}"></image>
        <span>${s.serviceName}</span>
        </div>
        `;
      });
      return `${nameList}`;
    },
  },

  async created() {
    document.cookie = `${Config.FUNCTION_ID}signup; path=/`;
    const response = await axios
      .get(API_PATH.CARSHARE_CORP_PARAM, this.getHeader(""))
      .catch((err) => {
        // メンテナンスモード
        if (err.response.data.code === "maintenance") {
          window.location.href = "/public/maintenance.html";
        }
      });
    this.corpParam = response.data.data.shift();
    this.$emit("setCorpParam", this.corpParam);
    localStorage.setItem("corpParam", JSON.stringify(this.corpParam));
    ErrorTracking.configureScope();
    const serviceResponse = await axios.get(
      `${API_PATH.SERVICE_LIST}`,
      this.getHeader(CARSHARE_CORP_ID, { exclusionFlg: 1 })
    );

    this.serviceList = serviceResponse.data.data;
  },
  methods: {
    /** 申込み */
    async register() {
      // 二重submit 防止 && ポインタ通信中
      this.disabledFlg = true;
      this.wait = "cursor: wait;";
      let responseCode;
      try {
        this.showLoading();
        const response = await axios.post(
          API_PATH.COGNITO_SIGN_UP,
          JSON.stringify({
            email: this.email,
            corpId: 0,
          }),
          this.getHeader(CARSHARE_CORP_ID)
        );
        responseCode = response.data.data;
      } catch (err) {
        // メンテナンスモード
        if (err.response.data.code === "maintenance") {
          window.location.href = "/public/maintenance.html";
        }

        if (err.response.data.errorCode !== "invalidParameter") {
          Swal.close();
          this.$logger.error(err);
          throw err;
        }

        setTimeout(() => {
          Swal.fire({
            icon: "warning",
            allowOutsideClick: false,
            text: err.response.data.message,
            grow: "row",
          });
          this.initButton();
        }, SUBMIT_INTERVAL);
      }

      if (responseCode === SIGNUP_CODE.SUCCESS) {
        this.$logger.info(`signUp was completed!! userName@${this.email}`);
        this.goComplate();
      } else if (responseCode === SIGNUP_CODE.REGISTERED) {
        setTimeout(() => {
          Swal.close();
          this.caution = ARTICLE.REGISTERED;
          this.registered = true;
          this.initButton();
        }, SUBMIT_INTERVAL);
      } else if (responseCode === SIGNUP_CODE.DIVERSION) {
        setTimeout(this.diviersion, SUBMIT_INTERVAL);
      }
    },
    /** 会員情報引き継ぎ確認 */
    async diviersion() {
      const serviceResponse = await axios.get(
        `${API_PATH.SERVICE_LIST}`,
        this.getHeader(CARSHARE_CORP_ID, {
          email: this.email,
          exclusionFlg: 1,
        })
      );
      this.belongServiceList = serviceResponse.data.data;

      Swal.fire({
        icon: "question",
        html: `お客様は本アカウントにて以下のカーシェアリングサービスにご登録済みのため、
        ご登録済みのカーシェアリングサービスから会員情報の一部を引き継ぐことができます。
        <br/>会員情報を引き継ぎますか？
        <br/>引き継がない場合は別のメールアドレスでご登録をお願いいたします。<br/><br/>
        ${this.belongServiceNames}
        `,
        showCloseButton: false,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: "はい（引き継ぐ）",
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: "いいえ（引き継がない）",
        cancelButtonAriaLabel: "Thumbs down",
        reverseButtons: true,
        grow: "row",
      }).then((result) => {
        if (!result.value) {
          // キャンセル処理
          this.caution = ARTICLE.NOT_TRANSFER;
          this.registered = true;
          this.initButton();
        } else {
          this.doTransfer();
        }
      });
    },
    /** 流用サインアップ */
    async doTransfer() {
      this.showLoading();
      axios
        .post(
          API_PATH.TRANSFER_SIGN_UP,
          JSON.stringify({ email: this.email, corpId: 0 }),
          this.getHeader(CARSHARE_CORP_ID)
        )
        .then(() => {
          Swal.close();
          this.$logger.info(`transfer signUp was completed!! userName@${this.email}`);
          this.goComplate();
        })
        .catch((err) => {
          // メンテナンスモード
          if (err.response.data.code === "maintenance") {
            window.location.href = "/public/maintenance.html";
          }

          const errMsg =
            err.response.data.errorCode === "invalidParameter"
              ? err.response.data.message
              : ARTICLE.SYSTEM_ERROR;
          Swal.fire({
            icon: "error",
            allowOutsideClick: false,
            html: errMsg,
            grow: "row",
          });
          this.initButton();
          this.$logger.error(err);
        });
    },
    goComplate() {
      window.location.search = "complete";
    },
    getHeader(carshareCorpId, param = null) {
      return {
        params: param,
        headers: {
          "content-type": "application/json",
          "cache-control": "no-cache",
          "X-App-Type": "front",
          "X-Carshare_Corp-Id": carshareCorpId,
        },
      };
    },
    initButton() {
      this.disabledFlg = false;
      this.wait = "";
    },
    /** loading dialog */
    showLoading() {
      Swal.fire({
        title: "処理中",
        html: "画面はそのままにしてください。",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
  },
};
</script>
